module.exports = __webpack_public_path__ + "static/media/mq.37d2d681.svg";